<template>
  <div
    class="Security-type-content-main"
    :class="isMobile ? `Security-type-content-main-mobile ${data.className}` : data.className"
    :style="{ background: `${data.bgImage}` }"
  >
    <div class="left">
      <div class="title">{{ data.title }}</div>
      <div class="small-title" v-show="data.smallTitle">{{ data.smallTitle }}</div>
      <div class="content">{{ data.content }}</div>
    </div>
    <div
      class="right"
      :style="{
        backgroundImage: `url(${data.icon})`,
        width: `${data.width}`,
        height: `${data.height}`
      }"
    >
    </div>
  </div>
</template>
<script>
  export default {
    name: 'SecurityTypeContent',
    props: {
      data: {
        type: Object,
        default: () => {}
      }
    }
  };
</script>
<style lang="scss" scoped>
  .Security-type-content-main {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 2.69rem;
    padding-right: 1.95rem;
    width: 100%;
    height: 4.53rem;
  }
  .left {
    .title {
      font-size: 0.43rem;
      font-family: PingFangTC-Medium, PingFangTC;
      font-weight: 500;
      color: #000000;
      line-height: 0.6rem;
      letter-spacing: 0.03rem;
    }
    .small-title {
      margin-top: 0.13rem;
      font-size: 0.32rem;
      font-family: PingFangTC-Regular, PingFangTC;
      font-weight: 400;
      color: #8b8b8b;
      line-height: 0.48rem;
    }
    .content {
      margin-top: 0.27rem;
      width: 5.85rem;
      font-size: 0.24rem;
      font-family: PingFangTC-Regular, PingFangTC;
      font-weight: 400;
      color: #8b8b8b;
      line-height: 0.48rem;
      letter-spacing: 0.01rem;
    }
  }
  .right {
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .custom-class {
    flex-direction: row-reverse;
    .left {
      text-align: right;
    }
  }
  .Security-type-content-main-mobile {
    padding-left: 1.02rem;
    padding-right: .92rem;
    width: 100%;
    height: 10.44rem;
    .left {
      .title {
        font-size: 0.82rem;
        line-height: 1.13rem;
        letter-spacing: 0.03rem;
      }
      .small-title {
        margin-top: 1.08rem;
        color: #424242;
        line-height: 0.98rem;
        letter-spacing: .05rem;
      }
      .content {
        margin-top: 0.56rem;
        width: 7.92rem;
        font-size: 0.61rem;
        color: #8b8b8b;
        line-height: 0.98rem;
        letter-spacing: .05rem;
        text-align: justify!important;
      }
    }
    .right {
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .custom-class {
      flex-direction: row-reverse;
      .left {
        text-align: right;
      }
    }
  }
</style>
